import { ProductType } from 'constants/productType';
import {
  useGetAccountInfoQuery,
  useGetDomesticRealEstateSymbolListQuery,
  useGetOverseasRealEstateSymbolListQuery,
  useGetSymbolListQuery,
} from 'views/utils/graphql/graphql';

export const useAccountStatus = () => {
  const [accountInfo, _reload] = useGetAccountInfoQuery({ requestPolicy: 'network-only' });
  return {
    accountInfo,
  };
};

export const useProgramList = () => {
  const [symbolListInfo, _reload] = useGetSymbolListQuery({
    variables: {
      page: 1,
      count: 100,
      productType: ProductType.LeaseFund,
    },
    requestPolicy: 'network-only',
  });

  return {
    symbolListInfo,
  };
};

export const useDomesticRealEstateItExplanationProgramList = () => {
  const [symbolListInfo, _reload] = useGetDomesticRealEstateSymbolListQuery({
    variables: {
      page: 1,
      count: 100,
      productType: ProductType.DomesticRealEstate,
    },
    requestPolicy: 'network-only',
  });

  return {
    symbolListInfo,
  };
};

export const useOverseasRealEstateProgramList = () => {
  const [symbolListInfo, _reload] = useGetOverseasRealEstateSymbolListQuery({
    variables: {
      page: 1,
      count: 100,
      productType: ProductType.OverseasRealEstate,
    },
    requestPolicy: 'network-only',
  });

  return {
    symbolListInfo,
  };
};
